import React, { useCallback } from "react";
import { FormControlLabel, TextField } from "@material-ui/core";

import { MaintenanceWindow } from "../../../../../dtos/site";
import { DEFAULT_MAINTENANCE_WINDOW } from "../../consts";

type TimeKey = keyof Pick<MaintenanceWindow, "startTime" | "endTime">;

const DB_TIME_FORMAT_REG_EX = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/; // "00:00:00 - 23:59:59"
const INPUT_TIME_FORMAT_REG_EX = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/; // "00:00 - 23:59"

const TIMES_LABELS: { [key in TimeKey]: string; } = {
    "startTime": "Starts at",
    "endTime": "Ends at",
};

interface Props {
    timeKey: TimeKey;
    value: string;
    onChange: (partialConfig: Partial<MaintenanceWindow>) => void;
    disabled?: boolean;
}

export function MaintenanceTimeField({
    timeKey,
    value,
    onChange,
    disabled = false,
}: Props) {
    const inputId = `maintenance_${timeKey}`;

    const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        if (disabled) return;
        const safeValue = getTimeValueForDB(e.target.value, timeKey);
        onChange({ [timeKey]: safeValue });
    }, [timeKey, onChange, disabled]);

    return (
        <FormControlLabel
            control={
                <TextField
                    id={inputId}
                    type="time"
                    value={getTimeValueForInput(value, timeKey)}
                    inputProps={{ step: 300 }}
                    onChange={handleChange}
                    style={{ marginLeft: "10px" }}
                />
            }
            label={TIMES_LABELS[timeKey]}
            htmlFor={inputId}
            labelPlacement="start"
            disabled={disabled}
            style={{ marginLeft: 0 }}
        />
    );
}

function getTimeValueForInput(unsafeValue: string | undefined, timeKey: TimeKey) {
    let safeValue = DEFAULT_MAINTENANCE_WINDOW[timeKey];
    if (unsafeValue && DB_TIME_FORMAT_REG_EX.test(unsafeValue)) {
        safeValue = unsafeValue;
    }
    return safeValue.split(":").slice(0, 2).join(":");
}

function getTimeValueForDB(unsafeValue: string | undefined, timeKey: TimeKey) {
    if (unsafeValue && INPUT_TIME_FORMAT_REG_EX.test(unsafeValue)) {
        return unsafeValue + ":00";
    }
    return DEFAULT_MAINTENANCE_WINDOW[timeKey];
}
